import { render, staticRenderFns } from "./TruckingCategories.vue?vue&type=template&id=2349074a&"
import script from "./TruckingCategories.vue?vue&type=script&lang=js&"
export * from "./TruckingCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports